import { getConfigFor } from '@/globals/config/helpers/getConfigFor';
import { translateInline } from '@/globals/translate/translateInline';

export const getStatusText = (status: string | undefined) => {
	switch (status?.toLowerCase()) {
		case undefined:
		case 'open':
			return undefined;
		case 'gesloten':
		case 'closed':
			return translateInline({
				nl: 'Let op: gesloten',
				en: 'Attention: closed',
			});
		case 'tijdelijk gesloten':
		case 'temporarily-closed':
			return translateInline({
				nl: 'Let op: tijdelijk gesloten',
				en: 'Attention: temporarily closed',
			});
		default:
			return status;
	}
};

export const subsidyFilterQueryKeys = getConfigFor.project<{
	subject: string;
	sector: string;
	status: string;
	schemeType: string;
}>({
	op: {
		subject: 'onderwerp',
		sector: 'branche',
		status: 'status',
		schemeType: 'type-regeling',
	},
	bgov: {
		subject: 'subject',
		sector: 'sector',
		status: 'status',
		schemeType: 'scheme-type',
	},
});

export const subsidyFilterGroupKeys = Object.values(subsidyFilterQueryKeys);

const normalizeValue = (value: string) => value.trim().toLowerCase();
export const normalizeStatus = (status: string | undefined) => {
	if (status == null || status === '' || normalizeValue(status) === 'open') {
		return 'open';
	}

	switch (normalizeValue(status)) {
		case 'gesloten':
		case 'closed':
			return 'closed';
		case 'tijdelijk gesloten':
		case 'temporarily-closed':
			return 'temporarily-closed';
		default:
			return normalizeValue(status);
	}
};

export type SubsidyFilterOption = {
	key: string;
	name: string;
};

export type SubsidyFilters = {
	subjects: Array<SubsidyFilterOption>;
	sectors: Array<SubsidyFilterOption>;
	schemes: Array<SubsidyFilterOption>;
	statuses: Array<SubsidyFilterOption>;
};

type SubsidyFilterGroupDefinition = {
	key: keyof SubsidyFilters;
	queryKeyRef: keyof typeof subsidyFilterQueryKeys;
	label: string;
	selectAllText: string;
};

export const filterGroups: Array<SubsidyFilterGroupDefinition> = [
	{
		key: 'subjects',
		queryKeyRef: 'subject',
		label: translateInline({ en: 'Topic', nl: 'Onderwerp' }),
		selectAllText: translateInline({
			en: 'All topics',
			nl: 'Alle onderwerpen',
		}),
	},
	{
		key: 'sectors',
		queryKeyRef: 'sector',
		label: translateInline({ en: 'Sector', nl: 'Branche' }),
		selectAllText: translateInline({ en: 'All sectors', nl: 'Alle branches' }),
	},
	{
		key: 'statuses',
		queryKeyRef: 'status',
		label: translateInline({ en: 'Status', nl: 'Status' }),
		selectAllText: translateInline({
			en: 'No preference',
			nl: 'Geen voorkeur',
		}),
	},
	{
		key: 'schemes',
		queryKeyRef: 'schemeType',
		label: translateInline({
			en: 'Type of scheme',
			nl: 'Type regeling',
		}),
		selectAllText: translateInline({
			en: 'No preference',
			nl: 'Geen voorkeur',
		}),
	},
];
